module.exports = ".readOnlyText{\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    padding-left: 0px;\n    background-color: #fff;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/edit/update-finance/update-finance.component.css
// module id = ./src/app/agora/components/account-data/accounts/edit/update-finance/update-finance.component.css
// module chunks = main